import type {Values} from "@wix/devzai-utils-common";

export const DoppeActionWidgetOpeningMode = {
    Inline: 'Inline',
    Popup: 'Popup',
    OpenCTA: 'OpenCTA',
} as const;

export type DoppeActionWidgetOpeningMode = Values<typeof DoppeActionWidgetOpeningMode>;